/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { CoreApiService } from '../core-api-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { deleteTenantById } from '../fn/iam-tenant/delete-tenant-by-id';
import { DeleteTenantById$Params } from '../fn/iam-tenant/delete-tenant-by-id';
import { getAllTenants } from '../fn/iam-tenant/get-all-tenants';
import { GetAllTenants$Params } from '../fn/iam-tenant/get-all-tenants';
import { getTenantById } from '../fn/iam-tenant/get-tenant-by-id';
import { GetTenantById$Params } from '../fn/iam-tenant/get-tenant-by-id';
import { postNewTenant } from '../fn/iam-tenant/post-new-tenant';
import { PostNewTenant$Params } from '../fn/iam-tenant/post-new-tenant';
import { putById } from '../fn/iam-tenant/put-by-id';
import { PutById$Params } from '../fn/iam-tenant/put-by-id';
import { TenantDto } from '../models/tenant-dto';

@Injectable({ providedIn: 'root' })
export class IamTenantAPI extends CoreApiService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAllTenants()` */
  static readonly GetAllTenantsPath = '/iam/tenant';

  /**
   * List all Tenants of the system.
   *
   * Returns a list of tenants.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllTenants()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllTenants$Response(params?: GetAllTenants$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TenantDto>>> {
    return getAllTenants(this.http, this.rootUrl, params, context);
  }

  /**
   * List all Tenants of the system.
   *
   * Returns a list of tenants.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllTenants$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllTenants(params?: GetAllTenants$Params, context?: HttpContext): Observable<Array<TenantDto>> {
    return this.getAllTenants$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<TenantDto>>): Array<TenantDto> => r.body)
    );
  }

  /** Path part for operation `postNewTenant()` */
  static readonly PostNewTenantPath = '/iam/tenant';

  /**
   * Create a new tenant.
   *
   * Creates a new tenant in the system
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postNewTenant()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postNewTenant$Response(params?: PostNewTenant$Params, context?: HttpContext): Observable<StrictHttpResponse<TenantDto>> {
    return postNewTenant(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a new tenant.
   *
   * Creates a new tenant in the system
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postNewTenant$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postNewTenant(params?: PostNewTenant$Params, context?: HttpContext): Observable<TenantDto> {
    return this.postNewTenant$Response(params, context).pipe(
      map((r: StrictHttpResponse<TenantDto>): TenantDto => r.body)
    );
  }

  /** Path part for operation `getTenantById()` */
  static readonly GetTenantByIdPath = '/iam/tenant/{id}';

  /**
   * Fetch a specific tenant entry from the system.
   *
   * Returns a tenant by the given id in the path.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTenantById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTenantById$Response(params: GetTenantById$Params, context?: HttpContext): Observable<StrictHttpResponse<TenantDto>> {
    return getTenantById(this.http, this.rootUrl, params, context);
  }

  /**
   * Fetch a specific tenant entry from the system.
   *
   * Returns a tenant by the given id in the path.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTenantById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTenantById(params: GetTenantById$Params, context?: HttpContext): Observable<TenantDto> {
    return this.getTenantById$Response(params, context).pipe(
      map((r: StrictHttpResponse<TenantDto>): TenantDto => r.body)
    );
  }

  /** Path part for operation `putById()` */
  static readonly PutByIdPath = '/iam/tenant/{id}';

  /**
   * Update an existing tenant entry.
   *
   * Updates an existing tenant entry in the system. Beware, that the id in the path and the body object of the tenant has to be equal.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  putById$Response(params: PutById$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return putById(this.http, this.rootUrl, params, context);
  }

  /**
   * Update an existing tenant entry.
   *
   * Updates an existing tenant entry in the system. Beware, that the id in the path and the body object of the tenant has to be equal.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `putById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  putById(params: PutById$Params, context?: HttpContext): Observable<void> {
    return this.putById$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteTenantById()` */
  static readonly DeleteTenantByIdPath = '/iam/tenant/{id}';

  /**
   * Delete an existing tenant entry.
   *
   * Delete an existing tenant entry in the system.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteTenantById()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteTenantById$Response(params: DeleteTenantById$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteTenantById(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete an existing tenant entry.
   *
   * Delete an existing tenant entry in the system.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteTenantById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteTenantById(params: DeleteTenantById$Params, context?: HttpContext): Observable<void> {
    return this.deleteTenantById$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
